<template>
  <div class="gestione-rottame">
    <div class="row row-custom">
      <div class="titolo-app col-xl-11 col-lg-8 col-1 no-padding">
        <span class="titolo-bold d-none d-lg-block">
          {{ $t('gestioneRottame.gestioneRottame').toUpperCase() }}
        </span>
      </div>

      <div class="icone col-xl-13 col-lg-16 col-23 no-padding">

        <div class="icona" v-show="!showGoToBuoni"></div>

        <div class="icona" v-show="(!showNuovo)"></div>

        <div class="icona" @click="goToConferme" v-show="showGoToConferme">
          <div class="icona-menu">
            <icon name="riv-clausole" scale="1.7"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('gestioneRottame.conferme')"></span>
          </div>
        </div>
        <div class="icona" @click="goToBuoni" v-show="showGoToBuoni">
          <div class="icona-menu">
            <icon name="riv-listProducts" scale="1.7"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('gestioneRottame.elencoBuoni')"></span>
          </div>
        </div>

        <div class="icona" @click="goToNuovo" v-if="showNuovo">
          <div class="icona-menu">
            <icon name="riv-ticket" scale="1.7"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('gestioneRottame.nuovoBuono')"></span>
          </div>
        </div>

      </div>

      <div id="contenitore_gestionerottame" class="contenitore col-24 no-padding" :style="{ height: contenitoreHeight + 'px', overflowY: (showScroll) ? 'auto' : 'hidden' }">
        <keep-alive>
          <router-view @hideScroll="hideScroll" @showScroll="showScroll = true" @goToNuovo="goToNuovo"></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
  import {bus} from '../../Bus'

  export default {
    name: 'GestioneRottame',
    props: ['contenitoreHeight'],
    i18n: {
      messages: {
        it_IT: {
          gestioneRottame: {
            elencoBuoni: 'Lista<br>Buoni',
            conferme: 'Lista<br>Conferme',
            gestioneRottame: 'Gestione Rottame',
            nuovoBuono: 'Nuovo<br>Buono di Scarico'
          }
        },
        fr_FR: {
          gestioneRottame: {
            elencoBuoni: 'Bonne<br>Liste',
            conferme: 'Confirmations',
            gestioneRottame: 'Gestion de la Ferraille',
            nuovoBuono: 'Nouveau<br>Bon de Déchargement'
          }
        },
        es_ES: {
          gestioneRottame: {
            elencoBuoni: 'Buena lista',
            conferme: 'Confirmaciones',
            gestioneRottame: 'Gestión de Chatarra',
            nuovoBuono: 'Nuevo<br>Vale de Descarga'
          }
        },
        de_DE: {
          gestioneRottame: {
            elencoBuoni: 'Übersicht<br>Entladescheine',
            conferme: 'Übersicht Verträge',
            gestioneRottame: 'Entladeschein Verwaltung',
            nuovoBuono: 'Neuen Entladeschein<br>erstellen'
          }
        },
        en_GB: {
          gestioneRottame: {
            elencoBuoni: 'Coupons<br>List',
            conferme: 'Confirmation<br>List',
            gestioneRottame: 'Scrap Management',
            nuovoBuono: 'Create New<br>Delivery Note'
          }
        }
      }
    },
    data () {
      return {
        ricercaPanelVisible: false,
        showScroll: true
      }
    },
    computed: {
      showGoToConferme: function () {
        return (this.$route.path.indexOf('/rottame/gestionerottame/conferme') < 0)
      },
      showGoToBuoni: function () {
        let path = this.$route.path
        return !(path.indexOf('conferme') >= 0 || path.indexOf('/gestionerottame/buoni') >= 0)
      },
      showNuovo: function () {
        let path = this.$route.path
        return (path.indexOf('/gestionerottame/buoni') >= 0)
      }
    },
    mounted: function () {
      if (this.$route.path === '/fornitura/situazioneordini/nuovo') {
        this.showNuovo = true
      }
    },
    methods: {
      goToNuovo: function () {
        sessionStorage.removeItem('WGR_buono')
        this.$router.push({name: 'GestioneRottameDettaglio'})
      },
      goToConferme: function () {
        this.$router.push({name: 'GestioneRottameConferme'})
        /*
        this.$nextTick(() => {
          bus.$emit('WebGestioneRottame-Ricerca')
        })
        */
      },
      goToBuoni: function () {
        this.$router.push({name: 'GestioneRottameElencoBuoni'})
        /*
        this.$nextTick(() => {
          bus.$emit('WebGestioneRottame-RicercaBuono')
        })
        */
      },
      hideScroll: function () {
        let container = this.$el.querySelector('#contenitore_gestionerottame')
        container.scrollTop = 0
        this.showScroll = false
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .gestione-rottame {
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px, @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 8px;
      padding-bottom: 8px;
      text-align: right;
      .icona:hover {
        cursor: pointer;
      }
      .icona {
        text-align: center;
        width: 180px;
        display: inline-block;
      }
      .icona-menu {
        padding-top: 2px;
        padding-left: 0;
        padding-right: 3px;
        text-align: right;
        display: inline-block;
        vertical-align: middle;
      }
      .label-menu {
        .set-font(@size: 13px; @family: 'os-semibold');
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        line-height: 17px;
      }
    }
    .contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/GestioneRottame.vue